/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "../";
import React from "react";
import { LogoLight } from "~/foundation/Components/Logo";

export const getDarkBlueColorTheme = (rtl: boolean): ColorTheme => ({
	name: "Dark Blue",
	colors: {
		ribbon: {
			bg: "themeBackgroundColors.darkBlue",
			color: "primary.white",
			border: "primary.neutralGrey",
			linkColor: "primary.white"
		},
		wordExplainer: {
			bg: "primary.white",
			color: "primary.text",
			activeColor: "primary.aramcoLinkBlue"
		},
		header: {
			bg: "themeBackgroundColors.darkBlue",
			bgInactive: "navigationColors.darkBgTransparent",
			color: "primary.neutralGrey",
			activeColor: "primary.white",
			hygieneColor: "primary.neutralGrey",
			hygieneGlobalContacts: "primary.neutralGrey",
			burgerMenuColor: "primary.white"
		},
		siteNavigation: {
			gradient: "siteNavigation.darkTheme.gradient",
			bg: "siteNavigation.darkTheme.bg",
			color: "siteNavigation.darkTheme.color",
		},
		footer: {
			bg: "themeBackgroundColors.darkBlue",
			color: "primary.neutralGrey",
		},
		breadcrumb: {
			linkColor: "aramcoBreadcrumb.darkTheme.linkColor",
			activeColor: "aramcoBreadcrumb.darkTheme.activeColor",
			aramcoA: "aramcoBreadcrumb.darkTheme.aramcoA",
			iconColor: "aramcoBreadcrumb.darkTheme.iconColor",
			linkColorCurrentPage: "aramcoBreadcrumb.darkTheme.linkColorCurrentPage",
		},
		generatedCard: {
			bg: "primary.white",
			color: "primary.text",
			linkColor: "primary.aramcoLinkBlue"
		},
		tags: {
			color: "primary.neutralGrey"
		},
		switch: {
			color: "primary.white",
		}
	},
	Logo: () => <LogoLight height={25} />,
	FooterLogo: () => <LogoLight height={29} />
});